import React from 'react';

import { makeStyles, Theme } from '@material-ui/core';

import { ToggleButton, Typography } from '../../../../components/atoms';

const useStyles = makeStyles((theme: Theme) => ({
  bottomLabel: {
    marginTop: theme.spacing(0.5),
  },
}));

export type TippingValue = {
  subValue?: string;
  value: string;
};

type Props = {
  className: string;
  onClick: () => void;
  selected: boolean;
  tippingOption: TippingValue;
};

export function TippingOption({
  className,
  onClick,
  selected,
  tippingOption,
}: Props): JSX.Element {
  const classes = useStyles();

  return (
    <ToggleButton
      className={className}
      onClick={onClick}
      selected={selected}
      value={tippingOption.value}
    >
      <div>
        <Typography>
          <strong>{tippingOption.value}</strong>
        </Typography>

        {tippingOption.subValue && (
          <Typography className={classes.bottomLabel}>
            {tippingOption.subValue}
          </Typography>
        )}
      </div>
    </ToggleButton>
  );
}
